import React from 'react';
import Card from '../components/common/Card';
import Badge from '../components/common/Badge';
import { Calendar, Download, FileText, Send, Share2 } from 'lucide-react';
const IBrief = () => {
  return <div className="space-y-6" data-id="element-438">
      <div className="flex items-center justify-between" data-id="element-439">
        <h1 className="text-2xl font-bold text-white" data-id="element-440">
          iBRIEF - AI Intelligence Briefing
        </h1>
        <div className="flex items-center space-x-3" data-id="element-441">
          <select className="bg-gray-800 text-sm text-white border border-gray-700 rounded px-3 py-1.5 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-442">
            <option data-id="element-443">Daily Brief</option>
            <option data-id="element-444">Weekly Brief</option>
            <option data-id="element-445">Custom Brief</option>
          </select>
          <div className="flex items-center px-2 py-1 bg-gray-800 rounded text-xs text-gray-400 border border-gray-700" data-id="element-446">
            <Calendar className="h-3 w-3 mr-1" data-id="element-447" />
            <span data-id="element-448">31 Aug 2023</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-449">
        {/* Main briefing content */}
        <div className="lg:col-span-3 space-y-6" data-id="element-450">
          <Card className="p-6" data-id="element-451">
            <div className="flex justify-between items-center mb-6" data-id="element-452">
              <div data-id="element-453">
                <h2 className="text-xl font-bold text-white" data-id="element-454">
                  Daily Executive Briefing
                </h2>
                <p className="text-sm text-gray-400" data-id="element-455">
                  Generated 31 Aug 2023, 06:00 WIB
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-456">
                <button className="p-2 text-gray-400 hover:text-white bg-gray-800 rounded" data-id="element-457">
                  <Download className="h-4 w-4" data-id="element-458" />
                </button>
                <button className="p-2 text-gray-400 hover:text-white bg-gray-800 rounded" data-id="element-459">
                  <Share2 className="h-4 w-4" data-id="element-460" />
                </button>
              </div>
            </div>
            {/* Highlight section */}
            <div className="mb-6" data-id="element-461">
              <h3 className="text-lg font-semibold text-white mb-3" data-id="element-462">
                Highlight Utama
              </h3>
              <ul className="space-y-3" data-id="element-463">
                <li className="flex items-start" data-id="element-464">
                  <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-red-900/50 text-red-400 mr-3 mt-0.5" data-id="element-465">
                    !
                  </span>
                  <p className="text-gray-300" data-id="element-466">
                    Peningkatan 27% aktivitas mencurigakan di perbatasan timur
                    dalam 72 jam terakhir dengan pola yang menunjukkan potensi
                    infiltrasi.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-467">
                  <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-red-900/50 text-red-400 mr-3 mt-0.5" data-id="element-468">
                    !
                  </span>
                  <p className="text-gray-300" data-id="element-469">
                    Deteksi 5 narasi disinformasi baru terkait ekonomi nasional
                    yang viral di media sosial dengan potensi dampak pada
                    stabilitas pasar.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-470">
                  <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-yellow-900/50 text-yellow-400 mr-3 mt-0.5" data-id="element-471">
                    !
                  </span>
                  <p className="text-gray-300" data-id="element-472">
                    Kontak diplomatik dengan negara X menunjukkan perubahan
                    sikap signifikan terhadap isu maritim yang perlu
                    diantisipasi dalam forum multilateral mendatang.
                  </p>
                </li>
              </ul>
            </div>
            {/* Issue sections */}
            <div className="space-y-4" data-id="element-473">
              <div className="border border-gray-800 rounded-lg overflow-hidden" data-id="element-474">
                <div className="bg-gray-800 px-4 py-3 flex justify-between items-center cursor-pointer" data-id="element-475">
                  <h3 className="font-medium text-white" data-id="element-476">Politik & Keamanan</h3>
                  <Badge variant="blue" data-id="element-477">Deputi II</Badge>
                </div>
                <div className="p-4 border-t border-gray-800" data-id="element-478">
                  <p className="text-gray-300 mb-3" data-id="element-479">
                    Analisis perkembangan situasi politik nasional menunjukkan
                    peningkatan tensi menjelang pelaksanaan pemilu. Terdeteksi
                    upaya mobilisasi massa oleh beberapa kelompok kepentingan
                    dengan narasi yang berpotensi memecah belah.
                  </p>
                  <p className="text-gray-300" data-id="element-480">
                    Rekomendasi: Perlu penguatan koordinasi dengan Polri dan TNI
                    untuk mengantisipasi potensi gangguan keamanan di 8 wilayah
                    yang teridentifikasi sebagai hotspot.
                  </p>
                </div>
              </div>
              <div className="border border-gray-800 rounded-lg overflow-hidden" data-id="element-481">
                <div className="bg-gray-800 px-4 py-3 flex justify-between items-center cursor-pointer" data-id="element-482">
                  <h3 className="font-medium text-white" data-id="element-483">Ekonomi Strategis</h3>
                  <Badge variant="green" data-id="element-484">Deputi VI</Badge>
                </div>
                <div className="p-4 border-t border-gray-800" data-id="element-485">
                  <p className="text-gray-300 mb-3" data-id="element-486">
                    Monitoring terhadap rantai pasok komoditas strategis
                    menunjukkan potensi gangguan pada distribusi BBM dan pangan
                    pokok di wilayah timur Indonesia. Teridentifikasi upaya
                    penimbunan oleh aktor tertentu yang berpotensi mempengaruhi
                    stabilitas harga.
                  </p>
                  <p className="text-gray-300" data-id="element-487">
                    Rekomendasi: Koordinasi dengan Kementerian Perdagangan dan
                    BUMN terkait untuk mengamankan stok dan distribusi, serta
                    penindakan terhadap pelaku penimbunan.
                  </p>
                </div>
              </div>
              <div className="border border-gray-800 rounded-lg overflow-hidden" data-id="element-488">
                <div className="bg-gray-800 px-4 py-3 flex justify-between items-center cursor-pointer" data-id="element-489">
                  <h3 className="font-medium text-white" data-id="element-490">
                    Siber & Disinformasi
                  </h3>
                  <Badge variant="red" data-id="element-491">Deputi IX</Badge>
                </div>
                <div className="p-4 border-t border-gray-800" data-id="element-492">
                  <p className="text-gray-300 mb-3" data-id="element-493">
                    Terdeteksi peningkatan serangan siber terhadap infrastruktur
                    kritis nasional dengan pola yang mengarah pada aktor negara
                    asing. Serangan terfokus pada sektor energi dan keuangan
                    dengan teknik yang semakin canggih.
                  </p>
                  <p className="text-gray-300" data-id="element-494">
                    Rekomendasi: Peningkatan level keamanan siber pada seluruh
                    infrastruktur kritis dan koordinasi dengan BSSN untuk
                    respons terpadu.
                  </p>
                </div>
              </div>
            </div>
          </Card>
          {/* AI Interaction Bar */}
          <Card className="p-4" data-id="element-495">
            <div className="flex items-center space-x-3" data-id="element-496">
              <div className="flex-1" data-id="element-497">
                <input type="text" placeholder="Tanyakan ke NEXUS atau minta analisis khusus..." className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-498" />
              </div>
              <button className="bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-3 rounded-lg flex items-center" data-id="element-499">
                <Send className="h-4 w-4 mr-2" data-id="element-500" />
                Generate Brief
              </button>
            </div>
            <div className="mt-2 flex flex-wrap gap-2" data-id="element-501">
              <button className="px-3 py-1 bg-gray-800 text-gray-400 rounded-full text-xs hover:bg-gray-700" data-id="element-502">
                Ringkas untuk Presiden
              </button>
              <button className="px-3 py-1 bg-gray-800 text-gray-400 rounded-full text-xs hover:bg-gray-700" data-id="element-503">
                Fokus Papua dan tambang ilegal
              </button>
              <button className="px-3 py-1 bg-gray-800 text-gray-400 rounded-full text-xs hover:bg-gray-700" data-id="element-504">
                Analisis tren 30 hari terakhir
              </button>
            </div>
          </Card>
        </div>
        {/* Sidebar */}
        <div className="space-y-6" data-id="element-505">
          <Card className="p-4" data-id="element-506">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-507">
              Previous Briefs
            </h3>
            <ul className="space-y-2" data-id="element-508">
              <li className="flex justify-between items-center p-2 hover:bg-gray-800 rounded cursor-pointer" data-id="element-509">
                <div className="flex items-center" data-id="element-510">
                  <FileText className="h-4 w-4 text-gray-400 mr-2" data-id="element-511" />
                  <span className="text-sm text-gray-300" data-id="element-512">
                    Daily Brief 30 Aug
                  </span>
                </div>
                <button className="text-cyan-500 hover:text-cyan-400" data-id="element-513">
                  <Download className="h-4 w-4" data-id="element-514" />
                </button>
              </li>
              <li className="flex justify-between items-center p-2 hover:bg-gray-800 rounded cursor-pointer" data-id="element-515">
                <div className="flex items-center" data-id="element-516">
                  <FileText className="h-4 w-4 text-gray-400 mr-2" data-id="element-517" />
                  <span className="text-sm text-gray-300" data-id="element-518">
                    Daily Brief 29 Aug
                  </span>
                </div>
                <button className="text-cyan-500 hover:text-cyan-400" data-id="element-519">
                  <Download className="h-4 w-4" data-id="element-520" />
                </button>
              </li>
              <li className="flex justify-between items-center p-2 hover:bg-gray-800 rounded cursor-pointer" data-id="element-521">
                <div className="flex items-center" data-id="element-522">
                  <FileText className="h-4 w-4 text-gray-400 mr-2" data-id="element-523" />
                  <span className="text-sm text-gray-300" data-id="element-524">
                    Weekly Brief 28 Aug
                  </span>
                </div>
                <button className="text-cyan-500 hover:text-cyan-400" data-id="element-525">
                  <Download className="h-4 w-4" data-id="element-526" />
                </button>
              </li>
            </ul>
          </Card>
          <Card className="p-4" data-id="element-527">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-528">
              Export Options
            </h3>
            <div className="space-y-2" data-id="element-529">
              <button className="w-full flex items-center justify-center space-x-2 bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded" data-id="element-530">
                <Download className="h-4 w-4" data-id="element-531" />
                <span data-id="element-532">Export as PDF</span>
              </button>
              <button className="w-full flex items-center justify-center space-x-2 bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded" data-id="element-533">
                <Download className="h-4 w-4" data-id="element-534" />
                <span data-id="element-535">Export as Slides</span>
              </button>
              <button className="w-full flex items-center justify-center space-x-2 bg-red-900/50 hover:bg-red-900/70 text-white px-4 py-2 rounded border border-red-800/50" data-id="element-536">
                <Share2 className="h-4 w-4" data-id="element-537" />
                <span data-id="element-538">Secure Share</span>
              </button>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};
export default IBrief;